import { render, staticRenderFns } from "./CommonDotLevels.vue?vue&type=template&id=0f5dee38&lang=pug&"
import script from "./CommonDotLevels.vue?vue&type=script&lang=ts&"
export * from "./CommonDotLevels.vue?vue&type=script&lang=ts&"
import style0 from "./CommonDotLevels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports